import { render, staticRenderFns } from "./ParentChildrenListView.vue?vue&type=template&id=dddfedfe&scoped=true"
import script from "./ParentChildrenListView.vue?vue&type=script&lang=js"
export * from "./ParentChildrenListView.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/abiturient/ParentChildrenListView.css?vue&type=style&index=0&id=dddfedfe&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddfedfe",
  null
  
)

export default component.exports